module.exports = __webpack_public_path__ + "static/xVerticalContactUSHome-3ba60877a65a0b217fb3aa9f2d28820b.svg";